import * as ngrxFormsActions from 'ngrx-forms';

export const formActions = [
  ngrxFormsActions.SetValueAction,
  ngrxFormsActions.SetErrorsAction,
  ngrxFormsActions.SetAsyncErrorAction,
  ngrxFormsActions.ClearAsyncErrorAction,
  ngrxFormsActions.StartAsyncValidationAction,
  ngrxFormsActions.MarkAsDirtyAction,
  ngrxFormsActions.MarkAsPristineAction,
  ngrxFormsActions.EnableAction,
  ngrxFormsActions.DisableAction,
  ngrxFormsActions.MarkAsTouchedAction,
  ngrxFormsActions.MarkAsUntouchedAction,
  ngrxFormsActions.FocusAction,
  ngrxFormsActions.UnfocusAction,
  ngrxFormsActions.MarkAsSubmittedAction,
  ngrxFormsActions.MarkAsUnsubmittedAction,
  ngrxFormsActions.AddArrayControlAction,
  ngrxFormsActions.AddGroupControlAction,
  ngrxFormsActions.RemoveArrayControlAction,
  ngrxFormsActions.RemoveGroupControlAction,
  ngrxFormsActions.SetUserDefinedPropertyAction,
  ngrxFormsActions.ResetAction,
];
